import { render, staticRenderFns } from "./subGameRoom.vue?vue&type=template&id=fb9b6a76"
import script from "./subGameRoom.vue?vue&type=script&lang=ts"
export * from "./subGameRoom.vue?vue&type=script&lang=ts"
import style0 from "./subGameRoom.vue?vue&type=style&index=0&id=fb9b6a76&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports